import styled, { css } from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const HubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;

  .breadcrumbs {
    margin-left: 20px;

    @media (${breakpoint.mdMin}) {
      margin-left: 0;
    }
  }

  .presented-by-banner {
    padding: 0 0 24px;
    @media (${breakpoint.lgMin}) {
      padding: 0;
    }
  }

  .topic-package {
    margin-bottom: 48px;
  }
`;
const commonPadding = css`
  padding: 0 20px;

  @media (${breakpoint.mdMin}) {
    padding: 0;
  }
`;

export const Header = styled.div`
  ${commonPadding}
  margin-bottom: 40px;

  &.the-latest {
    margin-bottom: unset;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  position: relative;
  gap: 24px;

  &.education {
    margin-top: 24px;

    @media (${breakpoint.lgMin}) {
      margin-top: 48px;
    }
  }

  ul {
    top: 40px;
    left: 16px;
  }

  @media (${breakpoint.mdMin}) {
    
    h1 {
      padding-left: 16px;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  max-width: 100%;

  .nativo-right-tout:has(> div:empty) {
    display: none;
  }

  .rr-sticky-hub {
    display: flex;
    justify-content: end;
  }

  .package-title {
    margin-top: 0;
    padding-left: 16px;

    @media (${breakpoint.mdMin}) {
      padding-left: 0;
    }
  }
`;

export const SidebarContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: 16px;
  margin-right: 16px;
  
  .video-module {
    margin: 0 0 16px;
    border-left: 0;
    padding-left: 0;
  }

  & > .sidebar-content-preview {
    flex: 1 1 100%;

    @media (${breakpoint.hybridMax}) {
      box-sizing: border-box;
      border-left: 0;
      margin-left: 0;
      padding-left: 0;
    }
  }

  .editors-picks {
    margin: 0 16px;
  }

  & > .eduRightRailNav:only-child{
    width: 100%;
  }

  @media (${breakpoint.mdMin}) {
    & > .sidebar-content-preview {
      flex: 1 1 50%;
    }
  
    .editors-picks {
      margin: 0;
      padding-right: 24px;
    }
  
    .video-module {
      padding-left: 48px;
    }
  }

  @media (${breakpoint.lgMin}) {
    margin-top: -4px;
  }

  @media (${breakpoint.hybridMin}) {
    min-width: 300px;
    width: 300px;
    display: block;

    .video-module {
      padding-left: 0;
    }
  }
`;

export const SidebarDesktop = styled.div`
  margin-top: -4px;
  @media (${breakpoint.hybridMin}) {
    min-width: 300px;
    width: 300px;
  }
`;

export const SidebarTablet = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  
  & > .sidebar-content-preview {
    flex: 1 1 50%;
    width: 50%;
    box-sizing: border-box;
    border-left: 0;
    margin-left: 0;
    padding-left: 0;
  }

  .editors-picks {
    margin: 0 16px;
    @media (${breakpoint.mdMin}) {
      margin: 0;
      padding-right: 24px;
    }
  }

  .video-module {
    margin: 0 0 16px;

    @media (${breakpoint.mdMin}) {
      padding-left: 24px;
    }
  }

  & > .eduRightRailNav:only-child{
    width: 100%;
  }
`;

export const SidebarMobile = styled.div`
  margin-left: 16px;
  margin-right: 16px;

  .video-module {
    margin: 0 0 16px;
    border-left: 0;
    padding-left: 0;
  }
`;

export const Excerpt = styled.p<{ theme: Theme }>`
  color: ${getColor('textPrimary')};
  font-family: ${font.graphikCond};
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 0.56px;
  line-height: 24px;
  text-transform: none;
  text-align: left;
  padding: 16px 16px 0;

  @media (${breakpoint.mdMin}) {
    margin-top: 16px;
    padding: 0;
    font-size: 24px;
    line-height: 150%;
  }

  a {
    color: ${getColor('textLink')};
    text-decoration: none;

    &:hover {
      color: ${getColor('textSecondary')};
    }
  }
`;

export const NoExcerpt = styled.div<{ theme: Theme }>`
  color: ${getColor('textPrimary')};;
  font-family: ${font.graphikCond};
  font-size: 24px;
  font-weight: 300;
  line-height: 30px;
  text-transform: none;
  text-align: left;
  margin-left: 20px;
  padding-top: 20px;
  padding-right: 16px;

  @media (${breakpoint.mdMin}) {
    margin-left: auto;
    font-size: 32px;
    margin-top: 15px;
  }

  @media (${breakpoint.lgMin}) {
    font-size: 32px;
    margin-top: 20px;
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (${breakpoint.hybridMin}) {
    flex-direction: row;
    gap: 24px;
  }
`;

export const ArticleWrapper = styled.div`
  &:not(.latest) {
    section:not(.nativo) {
      margin-top: 24px;
    }
    @media (${breakpoint.mdMin}) {
      section:not(.nativo) {
        margin-top: 40px;
      }
    }
  }

  section.termArchiveContentList ul.nativo-well-1,
  section.termArchiveContentList ul.nativo-well-2,
  section.termArchiveContentList ul.nativo-well-3 {
      margin-top: 0;
  }

  @media (${breakpoint.mdMax}) {

    ul.nativo-well-1 li:empty, 
    ul.nativo-well-2 li:empty, 
    ul.nativo-well-3 li:empty {
      height: calc(100vw) !important;
    }
  }

  @media (${breakpoint.mdMin}) {
    > div {
      margin-right: 0;
    }
  }

  @media (${breakpoint.hybridMin}) {
    width: calc(100% - 360px);
  }

  @media (${breakpoint.xlMin}) {
    margin-bottom: 48px;
  }

  & .show-more {
    display: flex;
    margin-right: auto;
    margin-left: auto;
    font-size: 16px;
    
    &.hidden {
      display:none;
      visibility: hidden;
      pointer-events: none;
    }
  }

  & .spinning-loader {
    margin: auto;
    margin-bottom: 24px;
  }
`;

export const LatestWrapper = styled.div`
  padding: 0px 16px;
  margin-bottom: 32px;
  @media (${breakpoint.mdMin}) {
    padding: 0;
  }
`;

export const BtnSpinnerDiv = styled.div`
  display: grid;

  &:has(button), &:has(div){
    margin-bottom:48px;
  }
`;
export const PageInfo = styled(Heading)<{ theme: Theme }>`
  padding-top: 8px;
  align-self: flex-start;
  font-weight: 400;
  line-height: 150%;

  &.the-latest {
    padding-top: unset;
  }
`;

export const PackageSpecialIssue = styled.div`
  margin: 24px 20px 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  img {
    margin-left: auto;
    margin-right: auto;
  }

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
    margin: 40px 0 40px 0;
    gap: 40px;

    img {
      flex: 1 1 50%;
    }
  }

  @media (${breakpoint.xlMin}) {
    margin: 48px 0 48px 0;
    img {
      min-width: 0;
    }
  }
`;

export const PackageSpecialText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (${breakpoint.mdMin}) {
    flex: 5;
    gap: 16px;
    flex: 1 1 50%;
  }

  @media (${breakpoint.xlMin}) {
    gap: 24px;
  }
`;

export const PackageSpecialHead = styled.h2<{ theme: Theme }>`
  font-family: ${font.saolText};
  font-weight: 600;
  line-height: 120%; /* 28.8px */
  margin-top: auto;

  @media (${breakpoint.mdMin}) {
    font-size: 32px;
  }
`;

export const PackageSpecialDek = styled.p`
  font-family: ${font.graphikCond};
  font-weight: 300;
  line-height: 150%; /* 24px */
  letter-spacing: 0.5px;
  margin-bottom: auto;

  @media (${breakpoint.mdMin}) {
    font-size: 20px;
  }
`;

export const BannerWrapper = styled.div`
  margin-top: 40px;
`;
